import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { Box, Grid, Icon, Typography } from '@material-ui/core';
import IxButton from './ix-button';
import {
  yellowBaseColor,
  blackLikeBackground
} from '../../constants/theme-colors';

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    //marginLeft: '-7.5em',
    position: 'fixed',
    bottom: '0',
    textTransform: 'uppercase',
    background: blackLikeBackground,
    fontSize: '0.2em',
    '& .MuiButtonBase-root': {
      height: '3em'
    },
    zIndex: theme.zIndex.staticNav
  },
  leftButtonLinks: {
    display: 'flex',
    marginTop: '5em',
    marginLeft: '8px',
    cursor: 'pointer',
    '& h6': {
      marginTop: '0.25em',
      color: yellowBaseColor
    }
  },
  leftChild: {
    paddingLeft: '1em',
    '& .MuiBox-root': {
      color: theme.palette.text.secondary
    }
  },
  rightChild: {
    marginLeft: '-4em',
    '& .MuiButtonBase-root': {
      marginBottom: '0.5em'
    },
    '& h5, h6': {
      textTransform: 'uppercase'
    },
    '& button': {
      paddingRight: '0.1em',
      float: 'right',
      marginTop: '0.5em'
    }
  },
  rightChildText: {
    marginRight: '8px'
  }
}));

const TakeoutBottomFunction = ({
  //history,
  rightChildText,
  isSubmit,
  leftBtnLink,
  rightBtnLink,
  orderDetail='false'
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation(['common']);
  return (
    <Grid container direction='row' className={classes.root}>
      <Grid
        container
        className={classes.leftChild}
        justify='flex-start'
        item
        xs={6}
      >
        <Box
          className={classes.leftButtonLinks}
          onClick={() => history.goBack()}
        >
          <Typography variant='h6'>{leftBtnLink}</Typography>
        </Box>
      </Grid>
      <Grid
        container
        className={classes.rightChild}
        justify='flex-end'
        item
        xs={6}
        onClick={() => history.push(rightBtnLink)}
      >
        <IxButton
          variant='contained'
          color='primary'
          type='submit'
        >
        <Typography variant='h6' className={classes.rightChildText}>{t(rightChildText)}</Typography>
        </IxButton>
      </Grid>
    </Grid>
  );
};

export default TakeoutBottomFunction;
